import { PaymentRow } from "@/api/payments";
import { formatDate } from "@/utils";
import { Chip } from "@mui/material";
import { FC } from "react";
import {
  Datagrid,
  FunctionField,
  List,
  Pagination,
  TextField,
} from "react-admin";
import {
  displayStatusChipColor,
  formatDisplayStatus,
  formatPurchaseKind,
} from "../../utils";
import { TopToolbar } from "../top-toolbar";


const PaymentsList: FC = () => (
  <List<PaymentRow>
    perPage={30}
    actions={<TopToolbar />}
    pagination={<Pagination rowsPerPageOptions={[10, 30, 50, 100]} />}
    sort={{ field: "createdAt", order: "DESC" }}
    empty={<></>}
  >
    <Datagrid
      bulkActionButtons={false}
      style={{ tableLayout: "fixed" }}
      rowClick="show"
    >
      <FunctionField<PaymentRow>
        label="Created"
        source="createdAt"
        sortable={true}
        render={({ createdAt }) => formatDate(createdAt, "MMM D, YYYY HH:mm")}
      />
      <FunctionField<PaymentRow>
        label="User"
        source="user.email"
        sortable={false}
        render={({ user }) => (
          <span
            style={{
              display: "block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {user?.email ?? "—"}
          </span>
        )}
      />
      <FunctionField<PaymentRow>
        label="Type"
        source="type"
        sortable={true}
        render={({ type, isRecurringProduct }) =>
          formatPurchaseKind(type, isRecurringProduct)
        }
      />
      <TextField<PaymentRow>
        noWrap
        label="Product"
        source="productTitle"
        style={{ display: "block" }}
        sortable={false}
      />
      <FunctionField<PaymentRow>
        label="Amount"
        source="price"
        sortable={true}
        render={({ price }) => `$${(price / 100).toFixed(2)}`}
      />
      <FunctionField<PaymentRow>
        label="Status"
        source="status"
        sortable={true}
        render={({ status, latestEventStatus, createdAt, type }) => (
          <Chip
            size="small"
            label={formatDisplayStatus(
              status,
              latestEventStatus,
              createdAt,
              type,
            )}
            color={displayStatusChipColor(
              status,
              latestEventStatus,
              createdAt,
              type,
            )}
          />
        )}
      />
      <FunctionField<PaymentRow>
        label="Last activity"
        source="latestActivityAt"
        sortable={true}
        render={({ latestActivityAt }) =>
          latestActivityAt
            ? formatDate(latestActivityAt, "MMM D, HH:mm")
            : "—"
        }
      />
      <FunctionField<PaymentRow>
        label="Error"
        source="latestErrorCode"
        sortable={false}
        render={({ latestErrorCode, latestErrorMessage }) =>
          latestErrorCode
            ? `${latestErrorCode}${latestErrorMessage ? `: ${latestErrorMessage}` : ""}`
            : "—"
        }
      />
    </Datagrid>
  </List>
);

export { PaymentsList };
